import React from 'react';
import { CTAButton } from './CTAButton';
import { PRODUCT_IMAGE } from '../data/hero';
export function FinalCTA() {
  return <section aria-label="Accede al sistema" className="bg-obsidian text-white" data-id="element-67" data-mp="3udoz2oyozioy">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-16 text-center lg:grid-cols-2 lg:py-24 lg:text-left" style={{
      paddingTop: "23px",
      paddingBottom: "33px"
    }} data-id="element-68" data-mp="c7twfnvkiyvm">
        <div data-id="element-69" data-mp="m4f1283oe7yx">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.92] sm:text-6xl" data-id="element-70" data-mp="m3wxeqeoorgz">
            Entrena con más estructura.
            <br data-id="element-71" data-mp="h3repzqe6fb1" />
            Organiza tu preparación.
            <br data-id="element-72" data-mp="vv1fhyznosg1" />
            <span className="text-electric" data-id="element-73" data-mp="vtgk675ip5h4">Afronta tu próximo desafío.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-md text-lg text-white/70 lg:mx-0" data-id="element-74" data-mp="qwztb56xod0c">
            Un sistema para organizar tu preparación desde los fundamentos hasta el día de competición.
          </p>
          <div className="mt-8 flex justify-center lg:justify-start" data-id="element-75" data-mp="zxek2k2o2kb8">
            <CTAButton data-id="element-76" data-mp="2c56eid8eslnm">Acceder al sistema completo</CTAButton>
          </div>
          <p className="mt-3 text-xs text-white/50" data-id="element-77" data-mp="2c70xvn4185pl">USD 19 · Pago único · Garantía de 7 días</p>
          <p className="mt-1 text-xs text-white/40" data-id="element-78" data-mp="2h5knbxhu3zmp">Sistema Triatlón Completo™ y sus cuatro bonos complementarios.</p>
        </div>
        <img src={PRODUCT_IMAGE} alt="SISTEMA TRIATLÓN COMPLETO™ con sus cuatro bonos complementarios" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto h-auto w-full max-w-[560px]" data-id="element-79" data-mp="2r2gp7kd89nia" />
      </div>
    </section>;
}